import { useState } from "react";
import { Fragment } from "react/jsx-runtime";
import { Button, Col, Modal, ModalBody, Row } from "reactstrap";
import { Href, VideoCallConferenceTitle } from "../../../../Constants/Constants";
import { FooterActions, VideoCallConferenceData } from "../../../../Data/Bonus/Elements";
import { dynamicImage, Image } from "../../../../Utils";

const VideoCallConference = () => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  return (
    <Fragment>
      <Button color="primary" className="fonts font_label" onClick={toggle}>{VideoCallConferenceTitle}</Button>
      <Modal isOpen={modal} fade toggle={toggle} centered>
        <ModalBody>
          <Row className="confimg">
            {VideoCallConferenceData.map((item, index) => (
              <Col xs="6" key={index}>
                <div className="vclimg bg-size" style={{ backgroundImage: `url(${dynamicImage(`avtar/${item}.jpg`)})`, backgroundSize: "cover", backgroundPosition: "center center", display: "block" }}>
                  <Image className="bg-img" src={dynamicImage(`avtar/${item}.jpg`)} alt="Avatar" style={{ display: "none" }}/>
                </div>
              </Col>
            ))}
          </Row>
        </ModalBody>
        <div className="modal-footer clfooter">
          <div>
            00:00:00
            <ul>
              {FooterActions.map((action, index) => (
                <li key={index}>
                  <a className={`icon-btn button-effect ${action.className || "btn-light"}`} href={Href}>{action.icon}</a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </Modal>
    </Fragment>
  );
};

export default VideoCallConference;
